import React from 'react'
import { Box, Grid } from '@mui/material';
import { MapContainer, TileLayer, Marker, Popup, CircleMarker } from 'react-leaflet';
import { IconOptions, Icon } from "leaflet"
import 'leaflet/dist/leaflet.css';


const CustomMarker = () => {
    return (
        <div style={{ width: '30px', height: '30px', backgroundColor: 'transparent' }}>
            <img src="https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon-2x.png" alt="Custom Marker" style={{ width: '100%', height: '100%' }} />
        </div>
    );
};
export const Map = () => {
    const position = [-33.0428555, -71.5166962]

    const customMarker = new Icon({
        iconUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon-2x.png',
        iconSize: [30, 40],
        iconAnchor: [15, 30],
    });

    return (
        <Grid item sx={{ height: { xs: 200, md: 600 }, ".leaflet-bottom": { display: "none" } }} md={6} xs={12}>
            <MapContainer center={[-33.0428555, -71.5166962]} zoom={13} style={{ height: '100%' }}>
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                <Marker position={[-33.0428555, -71.5166962]} icon={customMarker}>
                    <Popup>Limache 3421, Reitz II, oficina 816, viña del mar, 2520000 Valparaíso, Viña del Mar</Popup>
                </Marker>
            </MapContainer>
        </Grid >
    )
}
